import React from 'react';
import { StatusBar } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { createGroupChannelListFragment } from '@sendbird/uikit-react-native';
import { withSendbirdConnection } from '../components';
import { CustomHeader } from '@shared/components/md-design-system/Layout/CustomHeader';
import colors from '@shared/config/colorsConfig';
import { IGroupChannelContentProps } from '../types';
import { useTranslation } from 'react-i18next';

const GroupChannelListFragment = createGroupChannelListFragment({
    Header: () => {
        const { t } = useTranslation();
        return <CustomHeader className='px-8' title={t('screens.chat.title')} />;
    },
});

const GroupChannelListContent: React.FC<IGroupChannelContentProps> = () => {
    const navigation = useNavigation<any>();

    return (
        <>
            <StatusBar barStyle="dark-content" backgroundColor={colors.colorPalette.white} />
            <GroupChannelListFragment
                onPressCreateChannel={()=>{}}
                onPressChannel={channel => {
                    navigation.navigate('GroupChannel', { channelUrl: channel.url });
                }}
                channelListQueryParams={{ includeEmpty: true }}
            />
        </>
    );
};

export const GroupChannelListScreen = withSendbirdConnection(
    GroupChannelListContent,
    {
        useDetailedConnectionStatus: true,
    }
);
